import React, { useState, useRef } from 'react'
import { CenterContainer, TooltipBox, TooltipWrapper } from './index.styled'

const Tooltip = ({ position, text, children, background, margin, isShow = true, width, outline = false, mobWidth }) => {
	const [isHovered, setIsHovered] = useState(false)
	const [isFocused, setIsFocused] = useState(false)
	const targetRef = useRef(null)

	const showTooltip = isShow && (isHovered || isFocused)
	const marginTooltip = margin && `${parseFloat(margin) + 10}px`
	const layout = outline ? 'lf-outline' : ''

	const handleClick = () => {
		// After click, tooltip must hide — pointer can still be over the target
		// (e.g., download dialog steals focus but pointer stays put), and the
		// hover/focus state would otherwise keep the tooltip visible.
		setIsHovered(false)
		setIsFocused(false)
		if (targetRef.current) {
			targetRef.current.blur()
		}
	}

	return (
		<TooltipWrapper onPointerEnter={() => setIsHovered(true)}
										onPointerLeave={() => setIsHovered(false)}
										onFocus={() => setIsFocused(true)}
										onBlur={() => setIsFocused(false)}
										onClick={handleClick}
										ref={targetRef}
										showOnFocus={isFocused}>
			{showTooltip && (
				<CenterContainer position={position} margin={marginTooltip} width={width} mobWidth={mobWidth}>
					<TooltipBox background={background} position={position} className={layout}>
						{text}
					</TooltipBox>
				</CenterContainer>
			)}
			{children}
		</TooltipWrapper>
	)
}

Tooltip.displayName = 'Tooltip'
export default Tooltip
